export const TABLE_NAME_ASSIGNMENT_ACTIVE = 'vTableAssignmentsActive'
export const TABLE_NAME_ASSIGNMENT_ITEMS = 'vTableAssignmentItems'
export const TABLE_NAME_SINGLE_PARCEL_ASSIGNMENT_ACTIVE = 'vTableSingleParcelAssignmentsActive'
export const TABLE_NAME_CUSTOMERS_ACTIVE = 'vTableCustomersActive'
export const TABLE_NAME_STATISTICS = 'vStatisticsList'
export const TABLE_PACKING_SLIP_ASSIGNMENTS = 'vTablePackingSlipAssignments'
export const TABLE_PICKUPS_LIST = 'vTablePickups'
export const TABLE_ASSIGNMENTS_LIST = 'vTableAssignmentsList'
